import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=5b3aa3da&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=5b3aa3da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3aa3da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b3aa3da')) {
      api.createRecord('5b3aa3da', component.options)
    } else {
      api.reload('5b3aa3da', component.options)
    }
    module.hot.accept("./NewsDetail.vue?vue&type=template&id=5b3aa3da&scoped=true", function () {
      api.rerender('5b3aa3da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/articlemanagement/NewsManagement/NewsDetail.vue"
export default component.exports